var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorePlaceholderJosh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C11.6863 9 9.00003 11.6863 9.00003 15V20.5132L4.47021 34.1025C3.30159 37.6086 5.54223 41.2179 9.00003 41.889V60C9.00003 63.3138 11.6863 66 15 66H27H30H42H45H57C60.3138 66 63 63.3138 63 60V41.889C66.4578 41.2179 68.6985 37.6086 67.5297 34.1025L63 20.5132V15C63 11.6863 60.3138 9 57 9H15ZM45 60H57V42H52.5H36H19.5H15V60H27V51C27 46.0293 31.0293 42 36 42C40.9707 42 45 46.0293 45 51V60ZM33 60H39V51C39 49.3431 37.6569 48 36 48C34.3431 48 33 49.3431 33 51V60ZM10.1623 36L14.1623 24H18.9587L16.9586 36H12H10.1623ZM23.0414 36L25.0414 24H33V36H23.0414ZM39 36V24H46.9587L48.9585 36H39ZM55.0413 36L53.0415 24H57.8376L61.8378 36H60H55.0413ZM57 15V18H49.5H36H22.5H15V15H57Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorePlaceholderJosh);
export default __webpack_public_path__ + "static/media/store-placeholder-josh.50fe16c188c332e74c1e7b7351e32e5b.svg";
export { ForwardRef as ReactComponent };